import { render, staticRenderFns } from "./AddFacebookCampaignDialog.vue?vue&type=template&id=357433e0"
import script from "./AddFacebookCampaignDialog.vue?vue&type=script&lang=js"
export * from "./AddFacebookCampaignDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports